﻿(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.CampaignMedia = {};

    // Private Variables
    const profilePhoto = ".profile-photo-preview img";
    const photoIframeID = 'iframe-profile-photo-decorate';
    const videoIframeID = 'iframe-campaign-video-modal';

    const videoStatus = {
        loading: "loading",
        processing: "processing",
        videoCustom: "video-custom",
        videoDefault: "video-default",
        missing: "missing-video",
        error: "error"
    }
    const processingChecks = [];

    function setSelfieClose() {
        $(document).on("click", ".save-selfie", function (e) {
            e.preventDefault();
            var selected_value = $(".decorations input[type='radio']:checked").val();
            var $btn = $(this);
            var profilePhoto = ".profile-photo-preview img";
            const dbPathToImages = "Assets/images/" + M2.Util.config.theme;
            const token = $(this).closest("form").find("input[name='__RequestVerificationToken']").val();

            $.ajax({
                url: $("#update-selfie-url").val(),
                method: "POST",
                dataType: "json",
                data: {
                    decoration: dbPathToImages + "/selfie-decorations/" + selected_value + ".png",
                    '__RequestVerificationToken': token
                },
                beforeSend: function () {
                    $btn.addClass('disabled');
                    window.parent.$(profilePhoto).hide().attr("src", M2.Util.config.pathToImages + "loading-bar.gif").addClass("loading").show();
                },
                success: function (data, textStatus) {
                    if (data.success) {
                        setImage(profilePhoto, data.url);
                    } else {
                        alert(M2.CampaignMedia.config.errorSavingImageText);
                    }
                    $btn.removeClass('disabled');
                    window.parent.$('.modal').modal('hide');
                },
                error: function (jqXHR, textStatus, errorMessage) {
                    alert("error: " + errorMessage); // Optional
                    window.parent.$('.modal').modal('hide');
                }
            });
            
        });
    }

    // Set Storefront Photo
    function deletePhoto() {
        $(document).on("click", ".delete-photo", function (e) {
            e.preventDefault();
            var $btn = $(this);
            var deletePhotoUrl = $("#delete-selfie-url").val();
            var $storeFrontPhotoCheck = $("#set-storefront-photo");
            const $settings = $(".default-photo .settings");
            const token = $(this).closest("form").find("input[name='__RequestVerificationToken']").val();

            if (!confirm(M2.CampaignMedia.config.confirmPhotoDeleteTXT)) return false;
            else {
                if ($storeFrontPhotoCheck.attr('checked') === "checked") {
                    $storeFrontPhotoCheck.prop('checked', false);

                }
                M2.CampaignMedia.savePhotoStorefrontStatus();
            }
            
            $.ajax({
                url: deletePhotoUrl,
                method: "POST",
                data: {
                    '__RequestVerificationToken': token
                },
                dataType: "json",
                success: function (data, textStatus) {
                    if (data.success === true) {
                        setImage(profilePhoto, data.photo);
                        M2.CampaignMedia.selfieTools("hide");
                        $settings.addClass("hidden");
                        M2.Modal.resizeParentIframe();
                    }
                    window.parent.M2.Dashboard.refreshToDoList();
                    window.parent.M2.Modal.resizeModal();
                },
                error: function (jqXHR, textStatus, errorMessage) {
                    alert("error: " + errorMessage);
                    window.parent.M2.Modal.resizeModal();
                }
            });
        });
    }

    function deleteVideo(videoId) {
        const videoFile = document.getElementById(videoId);
        const deleteUrl = videoFile.dataset.deleteVideoUrl;
        const playerId = videoFile.dataset.videoPlayerId;
        const $storeFrontVideoCheck = $("#set-storefront-video");
        const token = $(videoFile).closest("form").find("input[name='__RequestVerificationToken']").val();

        if (!confirm(M2.CampaignMedia.config.confirmVideoDeleteTXT)) {
            return false;
        } else {
            if ($storeFrontVideoCheck.attr('checked') === "checked") {
                $storeFrontVideoCheck.prop('checked', false);
                clearInterval(processingChecks[videoId]);
            }
            M2.CampaignMedia.saveVideoStorefrontStatus();
            M2.Modal.resizeParentIframe();
        }

        $.ajax({
            url: deleteUrl,
            method: "POST",
            dataType: "json",
            data: {
                '__RequestVerificationToken': token
            },
            success: function (data, textStatus) {
                if (data.success === true) {
                    clearInterval(processingChecks[videoId]);
                    updateVideoDisplay(videoId, videoStatus.videoDefault, data.video);
                }
                window.parent.M2.Dashboard.refreshToDoList();
                window.parent.M2.Modal.resizeModal();
            },
            error: function (jqXHR, textStatus, errorMessage) {
                //console.log("error: " + errorMessage); // Optional
            }
        });
    }

    // Video Instructions
    function setInstructions() {
        $(document).on("click", ".open-instructions", function (e) {
            e.preventDefault();
            const $instructions = $('#instructions-container');
            $instructions.slideDown(function () {
                M2.Modal.resizeParentIframe();
            });  
        });

        $(document).on("click", ".close-instructions", function (e) {
            e.preventDefault();
            const $instructions = $('#instructions-container');
            $instructions.slideUp(function () {
                M2.Modal.resizeParentIframe();
            });
            $("html, body").animate({ scrollTop: 0 }, "fast");
        });
    }

    function setCurrentPhotoDecoration() {
        if (M2.Util.exists($("#selfie-decoration-url"))) {
            var url = $("#selfie-decoration-url").val();
            if (url) {
                var index = url.lastIndexOf("/") + 1;
                var filename = url.substr(index);
                filename = filename.slice(0, -4);
                $("input[name=decoration][value=" + filename + "]").trigger("click");
            }
        }

    }

    function setImage(imgSelector, imageUrl, loadingState) {
        loadingState = typeof loadingState !== 'undefined' ? loadingState : false;

        try {
            
            if (self !== top) {
                var parentIframeId = window.frameElement.id;
                window.parent.$(imgSelector).removeClass("loading").attr("src", imageUrl);
            }
            $(imgSelector).toggleClass("loading", loadingState);
            $(imgSelector).attr("src", imageUrl);
            $(imgSelector).on("load", function () {
                if (parentIframeId) {
                    M2.Modal.resizeParentIframe();
                    window.parent.M2.Modal.resizeModal();
                }
            });
        } catch (e) {
            console.log(e);
        }  
    }

    function setVideoUploadTools() {
        const $videoFiles = $('.video-file');

        $videoFiles.each(function () {
            const $videoFile = $(this);
            const videoId = $videoFile.attr('id');
            const videoPlayerId = $videoFile.data('video-player-id');
            const updateVideoUrl = $videoFile.data('update-video-url');
            const $uploadBtn = $("#" + $videoFile.data('upload-btn-id'));
            const $deleteBtn = $("#" + $videoFile.data('delete-btn-id'));
            const token = $videoFile.closest("form").find("input[name='__RequestVerificationToken']").val();

            $videoFile.click(function () {
                $(this).val('');
            });

            $videoFile.change(function () {
                $uploadBtn.removeClass('disabled');
            });

            $deleteBtn.click(function (e) {
                e.preventDefault();
                deleteVideo(videoId);
            });


            $uploadBtn.click(function (e) {
                e.preventDefault();

                if ($(this).hasClass('disabled')) {
                    return false;
                }

                // Set Storefront Video Status
                M2.CampaignMedia.saveVideoStorefrontStatus();

                // Start Video Upload
                updateVideoDisplay(videoId, videoStatus.loading);

                const params = {
                    "__RequestVerificationToken": token
                };

                M2.Video.upload(videoPlayerId, $uploadBtn, $videoFile, updateVideoUrl, function () {
                    updateVideoDisplay(videoId, videoStatus.processing);
                    // Start checking on the processing status
                    M2.CampaignMedia.startVideoProcessingCheck(videoId);
                }, params);
            });
        });
    }

    function setConfigOptions() {
        // Set config options
        if ('undefined' !== typeof M2_CampaignMedia_description) M2.CampaignMedia.config.description = M2_CampaignMedia_description;
        if ('undefined' !== typeof M2_CampaignMedia_confirmPhotoDeleteTXT) M2.CampaignMedia.config.confirmPhotoDeleteTXT = M2_CampaignMedia_confirmPhotoDeleteTXT;
        if ('undefined' !== typeof M2_CampaignMedia_confirmVideoDeleteTXT) M2.CampaignMedia.config.confirmVideoDeleteTXT = M2_CampaignMedia_confirmVideoDeleteTXT;
        if ('undefined' !== typeof M2_CampaignMedia_errorSavingImageText) M2.CampaignMedia.config.errorSavingImageText = M2_CampaignMedia_errorSavingImageText;
        if ('undefined' !== typeof M2_CampaignMedia_noFileChosenText) M2.CampaignMedia.config.noFileChosenText = M2_CampaignMedia_noFileChosenText;
        if ('undefined' !== typeof M2_CampaignMedia_chooseFileText) M2.CampaignMedia.config.chooseFileText = M2_CampaignMedia_chooseFileText;
    }

    function resetOrientation(srcBase64, srcOrientation, callback) {
        var img = new Image();

        img.onload = function () {
            var width = img.width,
                height = img.height,
                canvas = document.createElement('canvas'),
                ctx = canvas.getContext("2d");

            // set proper canvas dimensions before transform & export
            if (4 < srcOrientation && srcOrientation < 9) {
                canvas.width = height;
                canvas.height = width;
            } else {
                canvas.width = width;
                canvas.height = height;
            }

            // transform context before drawing image
            switch (srcOrientation) {
                case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
                case 3: ctx.transform(-1, 0, 0, -1, width, height); break;
                case 4: ctx.transform(1, 0, 0, -1, 0, height); break;
                case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
                case 6: ctx.transform(0, 1, -1, 0, height, 0); break;
                case 7: ctx.transform(0, -1, -1, 0, height, width); break;
                case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
                default: break;
            }

            // draw image
            ctx.drawImage(img, 0, 0);

            // export base64
            callback(canvas.toDataURL());
        };

        img.src = srcBase64;
    }

    function updateVideoDisplay(videoId, status, media_id) {

        media_id = media_id || "";
        const player_id = document.getElementById(videoId).dataset.videoPlayerId;
        const $videoUploadComponent = $("#" + videoId).closest(".video-upload-component");
        $videoUploadComponent.attr("data-view-mode", status);

        switch (status) {
            case videoStatus.videoCustom:
            case videoStatus.videoDefault:
                M2.Video.setPlayer(player_id, media_id, M2.Util.config.theme);
                window.parent.M2.Dashboard.refreshToDoList();
                break;
        }
        if (window.location !== window.parent.location) M2.Modal.resizeParentIframe(100);
    }

    function checkVideoProcess(videoId) {
        const uploader = document.getElementById(videoId);
        const processingStatusUrl = uploader.dataset.statusCheckUrl;
        const intervalProcess = processingChecks[videoId];
        const playerId = uploader.dataset.videoPlayerId;

        M2.Video.getProcessingStatus(processingStatusUrl).done(function (data, textStatus) {
            var status = data.status;
            switch (status) {
                case 1:
                    // Pending
                    updateVideoDisplay(videoId, videoStatus.processing);
                    break;
                case 2:
                    // Processed
                    var media_id = data.media_id;
                    updateVideoDisplay(videoId, videoStatus.videoCustom, media_id, 'campaign-video');
                    clearInterval(intervalProcess);
                    break;
                case 3:
                    //Error
                    updateVideoDisplay(videoId, videoStatus.error);
                    clearInterval(intervalProcess);
                    break;
                default:
                // Something went wrong
            }
        });
    }

    const uploadPhoto = function (elem) {
        const baseEndpoint = $($(elem).attr("data-url")).val();
        const tmpPreview = $(elem).attr("data-preview");
        var profilePhoto = $(elem).attr("data-preview") + " img";
        var oldImageURL = $(tmpPreview).attr("src");
        const $settings = $(".default-photo .settings");
        const token = $(elem).closest("form").find("input[name='__RequestVerificationToken']").val();

        const $uploader = $(elem).fineUploader({
            request: {
                endpoint: baseEndpoint,
                inputName: 'file',
                params: {
                    __RequestVerificationToken: token
                }
            },
            autoUpload: false,
            multiple: false,
            debug: false,
            text: {
                uploadButton: $(elem).html()
            },
            validation: {
                sizeLimit: 5242880
            }
        }).on('change', function (e) {
            var input = e.target.files[0];
            M2.CampaignMedia.resizePhoto(input, function (blob) {
                try {
                    var file = new File([blob], 'download.jpg');
                    $uploader.fineUploader('reset');
                    $uploader.fineUploader('addFiles', file);
                    $uploader.fineUploader('uploadStoredFiles');
                } catch (e) {
                    $uploader.fineUploader('uploadStoredFiles');
                }
            });
        }).on('upload', function (id, name) {
            setImage(profilePhoto, M2.Util.config.pathToImages + "loading-bar.gif", true);
            $(profilePhoto).fadeIn();
        }).on('complete', function (event, id, fileName, responseJSON) {

            if (responseJSON.success) {
                $(".qq-upload-list").fadeOut();
                setImage(profilePhoto, responseJSON.viewurl);
                M2.CampaignMedia.selfieTools("show");
                parent.M2.Dashboard.refreshToDoList();
                $settings.removeClass("hidden");
            } else if (responseJSON.error) {
                $(".qq-upload-list").fadeOut();
                setImage(profilePhoto, oldImageURL);
                $settings.addClass("hidden");
            }
            M2.Modal.resizeParentIframe();
            window.parent.M2.Modal.resizeModal();
            M2.CampaignMedia.savePhotoStorefrontStatus();
        }).on('error', function (id, name, errorReason, xhrOrXdr) {
            $(".qq-upload-list").fadeOut();
            setImage(profilePhoto, oldImageURL);
        });
    };


    M2.CampaignMedia = {
        config: {
            confirmPhotoDeleteTXT: "Are you sure you want to delete this photo?",
            confirmVideoDeleteTXT: "Are you sure you want to delete this video?",
            errorSavingImageText: "There was a problem saving your selfie decoration, please try again."
        },
        init: function () {
            setConfigOptions();
            // Photo Tools
            M2.CampaignMedia.setFileUploads();
            M2.CampaignMedia.setSelfieDecoration();
            setSelfieClose();
            setInstructions();
            deletePhoto();
            setCurrentPhotoDecoration();
            setVideoUploadTools();
        },
        resizePhoto: function (imgFile, callback, maxWidth, maxHeight) {
            maxWidth = (typeof maxWidth !== 'undefined') ? maxWidth : 500;
            maxHeight = (typeof maxHeight !== 'undefined') ? maxHeight : 500;

            var img = new Image();
            img.onload = function () {
           /* - Crop code
                const outputImageAspectRatio = 1;
                const inputWidth = img.naturalWidth;
                const inputHeight = img.naturalHeight;
                const inputImageAspectRatio = inputWidth / inputHeight;
                 const isPortrait = (inputHeight > inputWidth) ? true : false;

                let outputWidth = inputWidth;
                let outputHeight = inputHeight;


                if (inputImageAspectRatio > outputImageAspectRatio) {
                    outputWidth = inputHeight * outputImageAspectRatio;
                } else if (inputImageAspectRatio < outputImageAspectRatio) {
                    outputHeight = inputWidth / outputImageAspectRatio;
                }

                const outputX = (outputWidth - inputWidth) * .5;
                const outputY = (outputHeight - inputHeight) * .5;
                const canvas = document.createElement('canvas');

                // set it to the same size as the image
                canvas.width = outputWidth;
                canvas.height = outputHeight;
           
                // draw our image at position 0, 0 on the canvas
                const ctx = canvas.getContext('2d');
                ctx.drawImage(img, outputX, outputY);
             */
          
                var width = img.width,
                    height = img.height,
                    canvas = document.createElement('canvas'),
                    ctx = canvas.getContext("2d");

                if (width >= height && width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                } else if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                }

                canvas.width = width;
                canvas.height = height;
                
                ctx.drawImage(img, 0, 0, width, height);

                var dataURL = canvas.toDataURL({
                    format: 'jpeg',
                    quality: 0.8
                });
                var blobBin = atob(dataURL.split(',')[1]);
                var array = [];
                for (var i = 0; i < blobBin.length; i++) {
                    array.push(blobBin.charCodeAt(i));
                }
                var blob = new Blob([new Uint8Array(array)], { type: 'image/jpeg', lastModifiedDate: new Date(), name: 'profile-photo' });
                callback(blob);
                /*
                var imageN = new Image();
                imageN.id = "pic";
                imageN.src = dataURL;
                imageN.width = 100;
                imageN.height = 100;
                document.getElementById('popup-div').appendChild(imageN);
                */
            };
            img.src = URL.createObjectURL(imgFile);
        },
        startVideoProcessingCheck: function (videoId) {
            const checkDelay = 10000;
            const processingStatusUrl = document.getElementById(videoId).dataset.statusCheckUrl;
            const playerId = document.getElementById(videoId).dataset.videoPlayerId;
            clearInterval(processingChecks[videoId]);
            processingChecks[videoId] = setInterval(function () {
                checkVideoProcess(videoId);
            }, checkDelay);
        },
        setFileUploads: function () {
            if (M2.Util.exists($("#upload-photo-file"))) {
                uploadPhoto("#upload-photo-file");
            }

            if (M2.Util.exists($("#wtd-upload-photo-file"))) {
                uploadPhoto("#wtd-upload-photo-file");
            }
        },
        setSelfieDecoration: function () {
            $(document).on("change", ".decorations input[type='radio']", function () {
                const selected_value = $(".decorations input[type='radio']:checked").val();
                const $decorationLayer = $(this).closest('.default-photo').find('#decoration-layer');
                $decorationLayer.empty();
                if (selected_value !== "none") {
                    const decorationImage = $("<img>");
                    decorationImage.attr("src", M2.Util.config.pathToImages + "selfie-decorations/" + selected_value + ".png");
                    decorationImage.appendTo($decorationLayer);
                }
            });

            // Activate any active decorations
            if ($("#selfie-decoration-url").length) {
                var decorationNumber = $("#selfie-decoration-url").val().replace(/\D/g, '');
                if (decorationNumber > 0) $("#decoration-" + decorationNumber).trigger("click");
            }
        },
        selfieTools: function (status) {
            switch (status) {
                case "show":
                    $(".decorations, #profile-photo-modal .settings, .delete-photo, .btn.save-selfie").removeClass("hidden");
                    M2.Account.resetProfilePhotoSwitches();
                    break;
                case "hide":
                    $(".decorations, #profile-photo-modal .settings, .btn.save-selfie, .delete-photo.delete-media").addClass("hidden");
                    $('#decoration-layer').html('');
                    break;
            }
        },
        savePhotoStorefrontStatus: function () {
            var storefrontPhotoURL = $("#set-storefront-photo-url").val();
            var status = $("#set-storefront-photo").is(':checked') ? true : false;
            const token = $("#set-storefront-photo").closest("form").find("input[name='__RequestVerificationToken']").val();

            $.ajax({
                url: storefrontPhotoURL,
                type: 'POST',
                data: {
                    use: status,
                    '__RequestVerificationToken': token
                }
            });
        },
        saveVideoStorefrontStatus: function () {
            var storefrontVideoUrl = $("#set-storefront-video-url").val();
            var status = $("#set-storefront-video").is(':checked') ? true : false;
            const token = $("#set-storefront-video").closest("form").find("input[name='__RequestVerificationToken']").val();

            $.ajax({
                url: storefrontVideoUrl,
                type: 'POST',
                data: {
                    use: status,
                    '__RequestVerificationToken': token
                }
            });
        }
    };
})(jQuery);

$(function () {
    M2.CampaignMedia.init();
});